import { Typography } from "@platform/design-system";

import type { FieldComponent } from "../types";

const SectionHeaderComponent: FieldComponent<never> = ({ field }) => (
  <Typography
    variant="header-small"
    sx={{
      mt: 2,
      mb: 1,
      ...field.sx,
    }}
    className={field.className}
    style={field.style}
  >
    {field.label}
  </Typography>
);

export default SectionHeaderComponent;
